<svelte:options customElement="trebol-widget" />

<script lang="ts">
	import "./StartButton.svelte";
	import "./Wizard.svelte";
	interface Props {
		text?: string;
		client: string;
		flowid: string;
		tag: string;
		redirecturl: string;
	}

	let { text = "Verifica tu compañía", client, flowid, tag, redirecturl }: Props = $props();
</script>

<div class="container">
	<div>
		<start-button {text} {client} {flowid} {tag} {redirecturl}></start-button>
	</div>
	<div class="support">Powered By 🍀Trébol</div>
</div>

<style>
	.container {
		display: flex;
		flex-direction: column;
		width: 200px;
	}
	.support {
		font-size: 0.6em;
		text-align: right;
	}

	div {
		font-family:
			ui-sans-serif,
			system-ui,
			-apple-system,
			BlinkMacSystemFont,
			"Segoe UI",
			Roboto,
			"Helvetica Neue",
			Arial,
			"Noto Sans",
			sans-serif,
			"Apple Color Emoji",
			"Segoe UI Emoji",
			"Segoe UI Symbol",
			"Noto Color Emoji";
	}
</style>
